'use client';
import { useGlobalContext } from '../context/provider';

export default function ThemeWrapper({ children, notoFont }) {
  const { theme } = useGlobalContext();

  return (
    <body className={`${notoFont} ${theme || 'light_theme'}`}>
      {children}
    </body>
  );
}
